import { ArrowLeft2, ArrowRight2 } from "iconsax-react";
import React from "react";
import ReactPaginate from "react-paginate";
import PerPageSelector from "./PerPageSelector";

const Paginator = ({ meta, handlePageClick, perPage, handlePerPageChange, perPageOptions, children }) => {
  return (
    <div className="flex flex-row w-full px-[16px] py-[6px] gap-2 border-t border-[#EFF0F2] items-center justify-between font-normal text-[12px]">
      {/* Page number and total */}
      <div className="flex whitespace-nowrap">
        Showing {meta.page} of {meta.total_pages} ({meta.total} Total)
      </div>

      <div className="flex items-center gap-2">
        {children}

        {/* Number per page selector */}
        {perPage && handlePerPageChange && (
          <div className="flex">
            <PerPageSelector
              perPage={perPage}
              handlePerPageChange={handlePerPageChange}
              options={perPageOptions}
            />
          </div>
        )}

        {/* Page selector */}
        <div className="flex">
          <ReactPaginate
            onPageChange={handlePageClick}
            pageRangeDisplayed={2}
            marginPagesDisplayed={1}
            pageCount={meta.total_pages || 0}
            forcePage={meta.page ? meta.page - 1 : 0}
            breakLabel="..."
            previousLabel={<ArrowLeft2 size="16px" />}
            nextLabel={<ArrowRight2 size="16px" />}
            nextClassName="paginator-page-btn"
            previousClassName="paginator-page-btn"
            containerClassName="flex rounded-xl border font-medium"
            activeClassName="paginator-page-btn bg-[#F7F8F9] text-[#5C4BF5]"
            pageClassName="paginator-page-btn border-x"
            breakClassName="paginator-page-btn border-x"
          />
        </div>
      </div>
    </div>
  );
};

export default Paginator;
